export default __webpack_public_path__ + "static/media/Around_the_world.3d3467ba.svg";